import { Component, inject, model } from '@angular/core';
import { Drawer } from 'primeng/drawer';
import { DatePipe, AsyncPipe } from '@angular/common';
import { Log } from '../../../models/log.model';
import { QuoteService } from '../../quote.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-quote-history',
  imports: [Drawer, DatePipe, AsyncPipe],
  templateUrl: './quote-history.component.html',
  styleUrl: './quote-history.component.scss',
})
export class QuoteHistoryComponent {
  quoteService = inject(QuoteService);
  logs$: Observable<Log[]> = this.quoteService.logs$;
  visible = model(false);
}
